export const ElectronicFormNonGridValidator = (datalist) => {
  if (datalist.value instanceof Array) {
    return {
      base64: "",
      idcommand:
        datalist.element.ElsRecord.Type === "ComboBox"
          ? datalist.value.map((innervalue) => Number(innervalue.id))[0]
          : datalist.value
              .map((innervalue) => Number(innervalue.ItemValue))
              .join(","),
      iddetail: datalist.iddetail,
      value:
        datalist.element.ElsRecord.Type === "ComboBox"
          ? datalist.value.map((innervalue) => innervalue.label)[0]
          : datalist.value
              .map((innervalue) => innervalue.ItemContent)
              .join(","),
    };
  } else {
    const { element, name, ...rest } = datalist;
    return rest;
  }
};
